module.exports = __webpack_public_path__ + "media/images/partners/orange-5ca484338e78af7eadd082c60c456233.png";